export interface LegalConfig {
  company: string;
  taxCode: string;
  address: string;
  email: string;
  phone: string;
  effectiveDate: string;
}

/**
 * Thông tin pháp nhân hiển thị trên ba trang công khai.
 *
 * Cố tình để hằng số chứ không đọc biến môi trường: CRA nhúng env lúc build,
 * mà Dockerfile chỉ truyền REACT_APP_API_URL và REACT_APP_AGENT_API_URL — nên
 * mọi biến REACT_APP_LEGAL_* sẽ luôn rỗng ở bản production và giá trị mặc định
 * mới là thứ thật sự chạy. Các giá trị này phải khớp `config/legal.php` của
 * ebd-learning-api, nơi cùng nội dung được phục vụ.
 */
export const legalConfig: LegalConfig = {
  company: 'Công ty Cổ phần Phát hành Sách Giáo dục',
  taxCode: '0107319663',
  address: 'Tầng 1, nhà B, 187B Giảng Võ, P. Ô Chợ Dừa, Hà Nội',
  email: 'kinhdoanh@evovi.vn',
  phone: '024.6253.4305 – 024.6265.7745',
  effectiveDate: '07/09/2026',
};
